import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
  getActivityCompanyUsers () {
    return Api().get("/activity-company-users");
  },
  updateActivityCompanyUsers (params) {
    return Api().put("/activity-company-users",params);
  },
  addActivityCompanyUsers (params) {
    return Api().post("/activity-company-users",params);
  },
  getActivityCompanyUsers (params) {
    return Api().get("/activity-company-users/"+params);
  },
  deleteActivityCompanyUsers (params) {
    return Api().delete("/activity-company-users/"+params);
  },
  getUsersByCompanyActivity (params) {    
    return Api().get("/activity-company-users/users/"+params);
  },
  getUsersCompanyActivityByUser (params) {
    return Api().get("/activity-company-users-by-user/"+params);
  },
  deleteByCompanyId (params) {
    return Api().delete("/activity-company-users/users/"+params);
  },
}



// WEBPACK FOOTER //
// ./src/services/ActivityCompanyUsersService.js